import { PushNotifications } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';

const useDeregisterPush = () => {

    const handleDeregister = async () => {
        if (!Capacitor.isNativePlatform()) return;

        try {
            // 1️⃣ Unregister from FCM (important)
            await PushNotifications.unregister();

            // // 2️⃣ Remove token from backend (USER-SPECIFIC)
            // await pushTokenDeleteToken({
            //     memberId: dashMember.id
            // });

            // // 3️⃣ (Optional) Remove all listeners
            // await PushNotifications.removeAllListeners();

            console.log('Push notifications deregistered for user');
        } catch (err) {
            console.error('Deregister error:', err);
        }
    };

    return { handleDeregister };
};

export default useDeregisterPush;
